import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Container, Image } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";
import testimonial from '../../../../../Assets/adore-imgs/testimonial.jpg'
import left from '../../../../../Assets/adore-imgs/left-arrow.png'
import right from '../../../../../Assets/adore-imgs/right-arrow.png'
const Customer = () => {
  // const [customerData, setCustomerData] = useState([]);

  // const GetCustomerRewies = useCallback(() => {
  //   axios
  //     .get(`${base_url}/common/site_reviews`, { headers: postHeader })
  //     .then(({ data }) => {
  //       if (data.status === 1) {
  //         setCustomerData(data.data);
  //       }
  //     })
  //     .catch((error) => console.error("Error fetching reviews:", error));
  // }, []);

  // useEffect(() => {
  //   GetCustomerRewies();
  // }, [GetCustomerRewies]);

  // const updateTabIndex = () => {
  //   setTimeout(() => {
  //     document.querySelectorAll(".slick-slide").forEach((slide) => {
  //       const isHidden = slide.getAttribute("aria-hidden") === "true";
  //       console.log(`Slide ${slide.getAttribute("data-index")} hidden:`, isHidden); // Debugging Log

  //       slide.querySelectorAll("a, button, input").forEach((el) => {
  //         if (isHidden) {
  //           el.setAttribute("tabindex", "-1");
  //         } else {
  //           el.removeAttribute("tabindex");
  //         }
  //       });
  //     });
  //   }, 100);
  // };

  const customerData = [
  {
    username: "Ajoura Rama",
    rating: 5,
   review: "My fiancé worked with Adore Bijoux to create my engagement ring, and they truly went above and beyond to bring our vision to life. They were meticulous in every detail, taking the time to understand what he wanted while also offering expert recommendations to make the ring even more beautiful than I imagined.",
    date: "10 months ago",
  },
  {
    username: "Stephen Wong",
    rating: 5,
   review: "An absolutely amazing experience working with Chau and Adore Bijoux! Big box stores and online retailers just don’t compare to the quality, level of control, and value you’ll get here.",
    date: "2 months ago",
  },
];

  const settings2 = {
    accessibility: true,
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
      prevArrow: <img src={left} alt="left arrow" />,
    nextArrow: <img src={right} alt="right arrow" />,
    responsive: [
      { breakpoint: 1479, settings: { slidesToShow: 1, dots: false} },
      { breakpoint: 1025, settings: { slidesToShow: 1, dots: false} },
      { breakpoint: 600, settings: { slidesToShow: 1, dots: false} },
    ],
 
  };

  // useEffect(() => {
  //   updateTabIndex();
  // }, [customerData]);

  return (
    <section className="rcs_customer_say_section">
      <Container fluid className="showcase-container">
        <div className="d-flex align-items-center justify-content-center pb-lg-5 pb-4">
          <Heading className="text-center p-0">
            <h2>Happy Customers</h2>
          </Heading>
        </div>

        <Row>
          <Col md={6} xs={12} className="text-center">
            <Image src={testimonial} alt="testimonial"  className="img-fluid" />
          </Col>
          <Col md={6} lg={6} >
            <div className="rcs_customer_review_slider position-relative" >
              <div class="testimonial-icon1">
                                    <i class="fa fa-quote-left"></i>
                                </div>
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {customerData.map((customdata, index) => (
                   <div className="rcs_customer_review_slide_item_outer" key={index}>
                  <div className="rcs_customer_review_slide_item" key={index}>
                    <div className="rcs_customer_slide_title_img mb-4">
                     
                    </div>
                    <div className="rcs_customer_slide_text_content mb-4">
                      <p>{customdata?.review} <a style={{fontWeight:"400", colo:"var(--primary)"}} href="https://www.google.com/search?q=adorebijouxjewelers&oq=adorebijouxjewelers&aqs=chrome..69i57j0l4j69i60l3.6324j0j7&sourceid=chrome&ie=UTF-8#lrd=0x864c23785e5eef8f:0xc473229277e1fd34,1,,," target="_blank">Read More</a></p>
                          <Rating name="half-rating-read" value={customdata?.rating || 5} precision={0.5} size="lg" readOnly />
                    </div>
                    <div className="rcs_customer_review_footer d-flex align-items-center justify-content-center">
                      <div className="rcs_customer_review_slide_title text-center">
                        <h3>{customdata?.username}</h3>
                      </div>
                    </div>
                  </div>
                     <div className="rcs_customer_review_slide_img testimo-slider2 ">
                        <svg   onClick={() => window.open("https://www.google.com/search?q=adorebijouxjewelers&oq=adorebijouxjewelers&aqs=chrome..69i57j0l4j69i60l3.6324j0j7&sourceid=chrome&ie=UTF-8#lrd=0x864c23785e5eef8f:0xc473229277e1fd34,1,,,", "_blank")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="44" width="44"> <g fill="none" fill-rule="evenodd"> <path d="M482.56 261.36c0-16.73-1.5-32.83-4.29-48.27H256v91.29h127.01c-5.47 29.5-22.1 54.49-47.09 71.23v59.21h76.27c44.63-41.09 70.37-101.59 70.37-173.46z" fill="#4285f4"></path> <path d="M256 492c63.72 0 117.14-21.13 156.19-57.18l-76.27-59.21c-21.13 14.16-48.17 22.53-79.92 22.53-61.47 0-113.49-41.51-132.05-97.3H45.1v61.15c38.83 77.13 118.64 130.01 210.9 130.01z" fill="#34a853"></path> <path d="M123.95 300.84c-4.72-14.16-7.4-29.29-7.4-44.84s2.68-30.68 7.4-44.84V150.01H45.1C29.12 181.87 20 217.92 20 256c0 38.08 9.12 74.13 25.1 105.99l78.85-61.15z" fill="#fbbc05"></path> <path d="M256 113.86c34.65 0 65.76 11.91 90.22 35.29l67.69-67.69C373.03 43.39 319.61 20 256 20c-92.25 0-172.07 52.89-210.9 130.01l78.85 61.15c18.56-55.78 70.59-97.3 132.05-97.3z" fill="#ea4335"></path> <path d="M20 20h472v472H20V20z"></path> </g> </svg>
                      </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Customer;
